// extracted by mini-css-extract-plugin
export default {"indicatorWrap":"DropdownIndicatorPart_indicatorWrap__alEtn"};